(function (window, document) {
  'use strict';

  const defaultOptions = {
    documentCssClass: 'is--scroll-offset',
    offsetCssVariable: '--page-scroll-offset',
  };

  function ScrollOffset(element, options) {

    // Mische die übergebenen Optionen mit den Standardoptionen
    this.options = Object.assign({}, defaultOptions, options);

    // Speichere das DOM-Element, auf das das Plugin angewendet wird
    this.element = element;

    // Plugin intern initialisieren
    this.boot();
  }

  ScrollOffset.prototype.boot = function() {
    const _ = this;

    // _.indicateScrollProgress();

    document.addEventListener('scroll', function(event) {
      _.indicateScrollProgress();
    });
  }

  ScrollOffset.prototype.getScrollOffset = function() {
    let scrollOffset = parseInt(getComputedStyle(this.element).getPropertyValue(this.options.offsetCssVariable));

    if(isNaN(scrollOffset) === true) {
      scrollOffset = 0;
    }

    return scrollOffset;
  }

  ScrollOffset.prototype.indicateScrollProgress = function() {
    const _ = this;
    let scrollY = window.scrollY || window.pageYOffset;
    let scrollOffset = this.getScrollOffset();

    if(scrollY > scrollOffset) {

      // Event nur einmalig bei Aktivierung aufrufen
      if(document.body.classList.contains(this.options.documentCssClass) === false) {
        mint.fireEvent('scroll-offset.activate', null, _.element);
      }

      document.body.classList.add(this.options.documentCssClass);

    } else {

      // Event nur einmalig bei Deaktivierung aufrufen
      if(document.body.classList.contains(this.options.documentCssClass) === true) {
        mint.fireEvent('scroll-offset.deactivate', null, _.element);
      }

      document.body.classList.remove(this.options.documentCssClass);
    }
  }

  function initialize(element, options) {
    return new ScrollOffset(element, options);
  }

  mint.components.scrollOffset = initialize;
})(window, document);
